// User-facing strings for the QA Configuration tab.
const copies = {
  tabTitle: 'QA Configuration',
  scopeTable: {
    subOrganizationColumn: 'Sub Organization',
    lobColumn: 'LOB',
    statusColumn: 'Status',
    promptColumn: 'Prompt',
    fieldsColumn: 'Custom Fields',
    actionColumn: 'Configure',
    statusOn: 'On',
    statusOff: 'Off',
    promptConfigured: 'Configured',
    promptNotConfigured: 'Not configured',
    emptyTitle: 'No scopes',
    emptySubtitle: 'No sub-organization / line-of-business scopes are available for this organization yet.',
  },
  editor: {
    enabledLabel: 'Enable the QA expert for this scope',
    instructionsTitle: "QA expert's instructions",
    instructionsSubtitle: "Add any specific instructions for the QA expert when reviewing this scope's claims.",
    configuredFieldsSubtitle: 'If you want to capture additional information, you can add custom fields.',
  },
};

export default copies;
